"use strict";

require("core-js/modules/es.symbol.description");

const nop = Symbol.for('nop');
module.exports = nop;